import { VuexPersistence } from "vuex-persist";
import { Plugin } from "@nuxt/types";

/**
 * Vuex persistance plugin.
 *
 * Initializes the Vuex persistance object.
 *
 * @param {Context} context Nuxt context
 */
const plugin: Plugin = context => new VuexPersistence().plugin(context.store);
export default plugin;
